import React, { useEffect, useRef, useState } from 'react'
import Grid from '@mui/material/Grid2'
import { Container } from '@mui/material'
import { useNavigate } from "react-router-dom";
import AtomLink from '../../atoms/link/link'
import AtomButton from '../../atoms/button'
import { CirclePatternTop, Event6, Event7, Event8, Event9, Event10, Event11, DialogArrow, ChevronRight } from '../../helpers/constant/imageUrl'
import { Link } from "react-router-dom";
import getBlogFromFirebase, { BlogItem } from '../../services/BlogService';
import DOMPurify from "dompurify";

import './blog.scss'
import Loader from '../../Component/Loader';
import { DocumentSnapshot } from 'firebase/firestore';



const BlogTemplate: React.FC = () => {
     
    const [blogsItems, setBlogsItems] = useState<BlogItem[]>([]);
    const [loading, setLoading] = useState<Boolean>(true);
    const [lastBlogItem, setLastBlogItem] = useState<DocumentSnapshot | null>(null);
    const [error, setError] = useState<string | null>(null)
    const navigate = useNavigate();
    const [currentTab, setCurrentTab] = useState(0)
    const handleChange = (event: React.SyntheticEvent<Element, Event>, newValue: number) => {
        setCurrentTab(newValue)
    }
    useEffect(() => {
        const fetchAllBlog = async () => {
             
            try {
                setLoading(true);
                const {blogs:allBlogData,lastVisible} = await getBlogFromFirebase(6);
                setBlogsItems(allBlogData)
                setLastBlogItem(lastVisible);
                if(allBlogData?.length < 6){
                    setHasMore(false);
                }
                setError(null);

            } catch (error) {
                console.error("Error fetching all Blog:", error);
                setError("Failed to load Blog. Please try again.");
            } finally {
                setLoading(false);
            }
        };
        fetchAllBlog();
    }, []);


    const [hasMore, setHasMore] = useState(true);
    const isFetchingRef = useRef(false);

async function getNextBlogs() {
  if (isFetchingRef.current || !hasMore) return;
  isFetchingRef.current = true;
  setLoading(true);

  try {
    const lastItemId = blogsItems[blogsItems.length - 1];
    const {blogs:nextBlogs,lastVisible} = await getBlogFromFirebase(6, lastBlogItem);
    setLastBlogItem(lastVisible);

    if (nextBlogs.length === 0) {
      setHasMore(false);
    } else {
      setBlogsItems((prevBlogs) => [...prevBlogs, ...nextBlogs]);
    }
  } catch (err) {
    console.error("Error fetching more blogs", err);
    setError("Failed to load more blogs.");
  } finally {
    setLoading(false);
    isFetchingRef.current = false;
  }
}

const loaderRef = useRef<HTMLDivElement>(null);
// useEffect(() => {
//     if (!loaderRef.current || !hasMore) return;
//     const observer = new IntersectionObserver(
//         (entries)=>{
//             if (entries[0].isIntersecting) {
//                 getNextBlogs();
//             }
//         },
//         {
//             root: null,
//             rootMargin: '200px',
//             threshold: 1.0
//         }
//     )
//     if (loaderRef.current) {
//         observer.observe(loaderRef.current);
//     }
// },[getNextBlogs])



    return (
        <div className="media">
            <div className='gradient-section'>
                <div className='pattern-top'>
                    <img src={CirclePatternTop} alt='CirclePattern' />
                </div>
                <div className='pattern-bottom'>
                    <img src={CirclePatternTop} alt='CirclePattern' />
                </div>
                <Container className='container'>
                    <h1>Blogs</h1>
                    <p>Explore insightful articles, industry trends, and expert insights on specialty and fine chemicals. Our blog covers topics ranging from sustainable practices and innovative formulations to market updates and product applications. Join us as we share knowledge that empowers your business decisions and keeps you informed about the latest advancements in the chemical industry.</p>
                </Container>
            </div>
            <div className='all-updates'>
                {
                    


                        <Container className='container'>
                            <Grid container rowSpacing={{ xs: 1, sm: 2, md: 6 }} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                                {blogsItems.map((item) => {
                                    const sanitizedDescription = DOMPurify.sanitize(item.content || "");
                                    const shortDescription = sanitizedDescription.length > 120
                                        ? `${sanitizedDescription.substring(0, 120)}...`
                                        : sanitizedDescription;
                                    return (
                                        <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                                            <div className='card'>
                                                <img src={item.thumbnailImage} alt={item.heading} className='thumb' />
                                                <div className='pl-4 pr-4'>
                                                    <div className='title'>
                                                        {item.title}
                                                    </div>
                                                    <div className='white-section'>
                                                        <h5>{item.heading}</h5>
                                                        <p>{item?.shortdescription}</p>
                                                        <AtomLink
                                                            href={`/Blog/${item.id}`}
                                                            className='read-article'
                                                            startIcon={<img src={DialogArrow} alt='DialogArrow' />}
                                                        >
                                                            Read Article
                                                        </AtomLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </Grid>
                                    )
                                })


                                }

                               
                            </Grid>
                            {loading &&
                        <Loader /> }
                            {hasMore && <div className='text-center mt-16' ref={loaderRef}>
                                <AtomButton
                                    onClick={getNextBlogs}
                                    variant={'outlined'}
                                    size={'large'}
                                    endIcon={
                                        <img src={ChevronRight} alt='ChevronRight' />
                                    }
                                >
                                    VIEW MORE
                                </AtomButton>
                            </div>}
                        </Container>
                        }
            </div>
        </div>
    )
}

export default BlogTemplate